import * as React from 'react'

import { useCompanySelectionStore } from '@/modules/shared/stores/companySelectionStore'

type Injected = {
  /** Dodatkowo podaj `tenantId` — potrzebuje go tylko zakładka Użytkownicy. */
  withTenantId?: boolean
}

/**
 * Wstrzykuje `companyId` (i opcjonalnie `tenantId`) z `companySelectionStore`.
 *
 * Dziesięć kontenerów czytało z reduxa dokładnie to samo pole, więc zamiast dziesięciu
 * opakowań jest jedno. `mapStateToProps` nie widzi zustanda i nie przelicza się przy
 * jego zmianie, stąd HOC z prawdziwą subskrypcją.
 *
 * Przepuszcza ref — panel administracyjny sięga po instancję zakładki.
 */
export function withSelectedCompany<P extends object>(
  Wrapped: React.ComponentType<P>,
  { withTenantId = false }: Injected = {},
) {
  const WithSelectedCompany = React.forwardRef<unknown, any>((props, ref) => {
    const selectedCompany = useCompanySelectionStore((s) => s.selectedCompany)

    const injected: Record<string, unknown> = {
      companyId: selectedCompany?.id ?? '',
    }
    if (withTenantId) {
      injected.tenantId = (selectedCompany as any)?.tenantId
    }

    return <Wrapped ref={ref as any} {...(props as P)} {...(injected as any)} />
  })

  WithSelectedCompany.displayName = `withSelectedCompany(${
    (Wrapped as any).displayName || (Wrapped as any).name || 'Component'
  })`

  return WithSelectedCompany
}
